<div class="container-view">
    <div class="container-view__wrapper">
        <div class="header">
            <h1 class="header__title">
                {{'chartParams.title'|translate}}
            </h1>

            <div class="header__row">
                <div class="header__filters">
                    <app-filter-control
                        *ngIf="filtersVehicleConfig"
                        [selectedControlValue]="filtersVehicleCurrentFilters"
                        (onSubmitFilters$)="onChangeVehicleFilters($event, filtersVehicleConfig)"
                        [data]="filtersVehicleConfig"
                        [isVisibleSearchInput]="true"
                        [optionsSelectedCount]="filtersVehicleCurrentFilters?.selectedControlValue ? 1 : 0"
                        class="header__filters__vehicle"
                    ></app-filter-control>
                    <app-filter-control
                        #filterParams
                        [selectedControlValue]="filtersParamsCurrentFilters"
                        (onSubmitFilters$)="onChangeParamsFilters($event, filtersParamsConfig)"
                        [data]="filtersParamsConfig"
                        [isVisibleSearchInput]="true"
                        [isDisabled]="!filtersVehicleCurrentFilters"
                        [optionsSelectedCount]="filtersParamsCurrentFilters ? $any(filtersParamsCurrentFilters.selectedControlValue?.length) : 0"
                        [maxSelectable]="4"
                    ></app-filter-control>
                    <app-date-picker 
                        [(ngModel)]="selectedDate"
                        [maxSelectableDays]="1"
                    ></app-date-picker>
                    <p-button
                        (onClick)="submitFilters()"
                        class="header__filters__submit"
                        [label]="'chartParams.generateChart'|translate"
                        [loading]="isLoadingChart"
                        [disabled]="
                            !filtersVehicleCurrentFilters?.selectedControlValue ||
                            !filtersParamsCurrentFilters?.selectedControlValue?.length ||
                            !selectedDate
                        "
                    />
                </div>

                <div *ngIf="ChartConfig && !isLoadingChart" class="header__toolbox">
                    <span class="header__toolbox__title">{{'chartParams.exportChartView'|translate}}:</span>

                    <button (click)="getChartDataImage()" class="header__toolbox__btn image">
                        <i class="pi pi-image"></i>
                    </button>
                    <button (click)="generateXlsFile()" class="header__toolbox__btn xls">
                        <i class="pi pi-file-o"></i>
                    </button>
                    <button (click)="generatePdfFile()" class="header__toolbox__btn pdf">
                        <i class="pi pi-file-pdf"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="content__wrapper">
                <app-chart-line
                    #chartLineRef
                    *ngIf="ChartConfig && !isLoadingChart"
                    [ChartConfig]="ChartConfig"
                ></app-chart-line>

                <ng-container *ngIf="!chartData?.length">
                    <div class="empty-state">
                        <img src="/assets/img/emty-cars-params-chart.svg" alt="">

                        <div class="empty-state__text">
                            <span class="empty-state__text__title">{{'chartParams.noDataDisplay' | translate}}</span>
                            <span class="empty-state__text__desc">{{'chartParams.noDataDisplay2' | translate}}</span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
